import { defineMessages } from 'react-intl';

export default defineMessages({
    summaryPageHeader: {
        id: 'ml.quoteandbind.summary.Your policy information at a glance',
        defaultMessage: 'Your policy information at a glance'
    },
    summaryPageHeaderStatement: {
        id: 'ml.quoteandbind.summary.Refer to your policy for complete details. In the event of a conflict, the policy prevails.',
        defaultMessage: 'Refer to your policy for complete details. In the event of a conflict, the policy prevails.'
    },
    summaryPageHeaderStatementQB: {
        id: 'ml.quoteandbind.summary.Your policy is not bound.',
        defaultMessage: 'Your policy is not bound. You may review your quote details at a glance. You must click continue at the bottom to finalize your purchase.'
    },
    printPolicySummary: {
        id: 'ml.quoteandbind.summary.Print Policy Summary',
        defaultMessage: 'PRINT POLICY SUMMARY'
    },
    summaryStatement: {
        id: 'ml.quoteandbind.summary.summaryStatement',
        defaultMessage: 'This summary of insurance coverage is issued as a matter of information only and confers no rights upon the holder. This summary does not amend, extend, or alter the coverage, terms, exclusions or conditions afforded by the policy referenced herein.'
    },
    continueText: {
        id: 'ml.quoteandbind.summary.continueText',
        defaultMessage: 'You\'ll need to {signPolicyDocuments} electronically next'
    },
    validateSmartHomeDevicesText: {
        id: 'ml.quoteandbind.summary.validate your smart home devices',
        defaultMessage: 'validate your smart home devices'
    },
    signPolicyDocumentsText: {
        id: 'ml.quoteandbind.summary.sign your policy documents',
        defaultMessage: 'sign your policy documents'
    },
    continuTextforGPA : {
        id: 'ml.quoteandbind.summary.agent.continueText',
        defaultMessage: 'We\'ll get {requiredSignatures} next'
    },
    requiredSignatures : {
        id: 'ml.quoteandbind.summary.agent.Required Sigantures',
        defaultMessage: 'Required Signatures'
    }

});
